import { Action, Dispatch } from 'redux';
import * as ActionsTypes from './actionsType';
import type { DeviceInfo } from '@capacitor/device';

export function setDevice(device: DeviceInfo) {
    return (dispatch: Dispatch): Action<ActionsTypes.SetDevice> => {
        return dispatch({ type: ActionsTypes.SET_DEVICE, payload: device });
    };
}
